
import React from 'react';
import { NavigationHub } from './layout/NavigationHub';
import { useSal } from '../contexts/SalContext';
import { toast } from 'react-hot-toast';

export const Header: React.FC = () => {
  const {
    isSimulating, isSimpleView, setIsSimpleView, actions,
    safeConfig, setConfig, orders, handleLogout, userProfile,
    toggleDispatcherTheme,
    viewMode, setViewMode, isAdmin
  } = useSal();

  return (
    <NavigationHub
      isSimulating={isSimulating} 
      isSimpleView={isSimpleView} 
      isSyncing={actions.isSyncing}
      onOpenDeliveryModal={() => actions.toggleModal('openDelivery', true)} 
      onSimulateWebhook={actions.handleSimulateWebhook}
      onManualSync={actions.handleManualActiveSync} 
      onNewOrderModal={() => actions.toggleModal('paste', true)}
      onToggleSimpleView={() => setIsSimpleView(!isSimpleView)}
      onOpenSettings={() => isAdmin ? actions.toggleModal('settings', true) : toast.error("Área restrita.")}
      onOpenStaffPin={() => actions.toggleModal('staffPin', true)} 
      autoPilotEnabled={safeConfig.autoPilotEnabled}
      onToggleAutoPilot={() => setConfig({ ...safeConfig, autoPilotEnabled: !safeConfig.autoPilotEnabled })} 
      config={safeConfig}
      orders={orders}
      onToggleEconomicMode={() => setConfig({ ...safeConfig, isEconomicMode: !safeConfig.isEconomicMode })}
      onToggleSolarMode={toggleDispatcherTheme}
      onLogout={handleLogout} 
      userRole={userProfile?.role}
      viewMode={viewMode} 
      setViewMode={setViewMode}
    />
  );
};
